<template>

  <v-container fluid class="page-content vehicle-list-table">

    <v-row class="mb-3">
      <v-col class="pt-2">
        <div class="page-title">
          <v-icon class="pr-1">mdi-car</v-icon>
          Vehicles
        </div>
      </v-col>
    </v-row>

    <v-data-table
        :headers="tableHeaders"
        :items="vehicleItems"
        :search="search"
        :options.sync="dataOptions"
        :footer-props="paginationOptions"
        :loading="isDataLoading"
        :server-items-length="totalItems"
        @click:row="goToItemPage">

      <!-- license plate -->
      <template v-slot:[`item.license_plate`]="{ item }">
        <span style="font-size:1.24em">
          <router-link :to="generateVehiclePageLink(item)">
            {{ item.license_plate }}
          </router-link>
        </span>
      </template>

      <!-- nickname -->
      <template v-slot:[`item.nickname`]="{ item }">
        <span>{{ item.nickname }}</span>
      </template>

      <!-- year -->
      <template v-slot:[`item.year`]="{ item }">
        <span>{{ item.year }}</span>
      </template>

      <!-- make -->
      <template v-slot:[`item.make`]="{ item }">
        <span>{{ item.make }}</span>
      </template>

      <!-- model -->
      <template v-slot:[`item.vehicle_model`]="{ item }">
        <span>{{ item.vehicle_model }}</span>
      </template>

      <!-- color -->
      <template v-slot:[`item.color`]="{ item }">
        <span>{{ item.color }}</span>
      </template>

      <!-- status -->
      <template v-slot:[`item.vehicle_status`]="{ item }">
        <v-chip label outlined :class="item.vehicle_status" v-if="item.vehicle_status">
          {{ item.vehicle_status }}
        </v-chip>
      </template>
    </v-data-table>

  </v-container>

</template>

<script>
export default {
  name: 'VehicleListDataTable',

  data () {
    return {
      isDataLoading: false,
      vehicleData: null,
      dataLoadingError: null,
      paginationOptions: {
        'items-per-page-options': [10, 25, 50, 100]
      },
      dataOptions: {
        itemsPerPage: 10,
        // NOTE - Currently enabled for single field sort only !!!
        sortBy: ['vehicle_status'],
        sortDesc: [true]
      },
      search: null
    }
  },

  computed: {
    tableHeaders () {
      return [
        { text: 'License plate', width: '125px', value: 'license_plate' },
        { text: 'Nickname', value: 'nickname' },
        { text: 'Year', value: 'year' },
        { text: 'Make', value: 'make' },
        { text: 'Model', value: 'vehicle_model' },
        { text: 'Color', value: 'color' },
        { text: 'Status', value: 'vehicle_status' }
      ]
    },
    vehicleItems () {
      return (this.vehicleData) ? this.vehicleData.items : []
    },
    dataMeta () {
      return (this.vehicleData) ? this.vehicleData.meta : {}
    },
    totalItems () {
      return this.dataMeta.total_items || 0
    }
  },

  watch: {
    // Observe changes invoked by the data-table component (e.g. pagination, sorting)
    dataOptions: {
      handler () {
        this.queryData()
      },
      deep: true
    }
    // Observe changes to the search field
    // search: function (updated) {
    //   this.queryData()
    // }
  },

  methods: {
    // Refresh action to call from parent components
    refresh () {
      this.queryData()
    },

    // Display a date
    formatDate (date) {
      return (date) ? this.$root.utils.dateFormat(date, 'MMMM D, YYYY') : ''
    },

    // Generate link data for vehicle item page
    generateVehiclePageLink (item) {
      if (item && item.model) {
        return {
          name: 'vehicle-item',
          params: { vehicleId: item.id }
        }
      } else {
        return ''
      }
    },

    // Navigate to vehicle item page
    goToItemPage (item) {
      if (item && item.model) {
        this.$root.goTo('vehicle-item', { vehicleId: item.id })
      } else {
        console.error('Invalid item data. Cannot invoke item page.')
      }
    },

    // Perform query of vehicles
    async queryData () {
      this.isDataLoading = true

      try {
        // Build sort
        // NOTE - Currently enabled for single field sort only !!!
        let orderBy = null
        const sortBy = this.dataOptions.sortBy
        const sortDesc = this.dataOptions.sortDesc
        if (sortBy && sortBy.length > 0) {
          const isDesc = (sortDesc && sortDesc.length > 0) ? sortDesc[0] : false
          const prefix = (isDesc) ? '-' : ''
          orderBy = `${prefix}${sortBy[0]}`
        }

        // Build pagination
        const page = this.dataOptions.page || 1
        const limit = this.dataOptions.itemsPerPage
        const skip = (page === 1) ? 0 : (page - 1) * limit

        // Build request input
        const params = {
          skip,
          limit,
          with: ''
        }

        // Apply sorting
        if (orderBy) params.order_by = orderBy

        // Apply search query (for name only)
        if (this.search) params['name.contains'] = this.search

        // Retrieve results
        this.vehicleData = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: 'vehicles',
          opts: { params }
        })
      } catch (err) {
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style>
  .vehicle-list-table .theme--dark.v-data-table {
    /* cursor: pointer; */
  }

  .vehicle-list-table .status-tag {
    text-transform: uppercase !important;
  }

  .vehicle-list-table .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .vehicle-list-table .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .vehicle-list-table .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 65px;
  }

  .vehicle-list-table .v-data-table a {
    text-decoration: none;
  }
  .vehicle-list-table .v-data-table a:hover {
    text-decoration: underline;
  }
</style>
